import { EventEmitter } from "events";

const toastEmitter = new EventEmitter();

export default toastEmitter;
